<template>
  <BModalConfirm
    ref="modal"
    v-bind="$attrs"
    cancel-btn="Отменить"
    success-btn="Изменить"
    @submit="close(true)"
    @closed="$emit('closed')"
  >
    <template #header>
      Принадлежность к АТЕ
    </template>

    <BAteTreeFormFormdataStarted
      :regions.sync="regions"
      :municipalities.sync="municipalities"
      :schools.sync="schools"
      :model="model"
      max-height="480px"
      autofocus
    />
  </BModalConfirm>
</template>
<script>
import BModalConfirm from '@/components/modals/BModalConfirm.vue'
import BTextFieldAteModal from '@/components/forms/BTextFieldAte/BTextFieldAteModal.vue'
import BAteTreeFormFormdataStarted from '@/components/forms/BAteTree/BAteTreeFormFormdataStarted.vue'

export default {
  name: 'BTextFieldAteFormdataStartedModal',
  components: { BModalConfirm, BAteTreeFormFormdataStarted },
  extends: BTextFieldAteModal,
}
</script>
